import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'
import { readLocalProjectFile } from '@cli-utils/paths.js'
import { buildRenamePreviewPaths } from '@core-engine/snapshots/ast-substitution/build-rename-preview-paths.js'
import { transformContentForRenamePlan } from '@core-engine/snapshots/ast-substitution/transform-content-for-rename-plan.js'

export function collectRenamePreview(
  cwd: string,
  remotePaths: string[],
  plan: RenamePlan
): { previewLines: string[]; warnings: string[] } {
  const previewLines: string[] = []
  const warnings: string[] = []

  for (const previewPath of buildRenamePreviewPaths(remotePaths, plan)) {
    const content = readLocalProjectFile(cwd, previewPath.sourcePath)
    if (content == null) {
      continue
    }

    const result = transformContentForRenamePlan(
      content,
      previewPath.sourcePath,
      plan,
      previewPath.displayPath
    )

    if (result.parseFailed) {
      warnings.push(
        `AST rename preview skipped for ${previewPath.displayPath}: parse failed, merge will fall back for that file`
      )
      continue
    }

    for (const change of result.previewChanges) {
      previewLines.push(
        `  ${change.path}:${change.line}\n    - ${change.before || '(empty)'}\n    + ${change.after || '(empty)'}`
      )
    }
  }

  return { previewLines, warnings }
}
